import React from 'react';

interface ControlsInfoProps {
    controls?: string[];
    instructions?: string[];
    isPositioned?: boolean; // Whether to use absolute positioning
}

const ControlsInfo: React.FC<ControlsInfoProps> = ({
    controls = ['Use ARROW KEYS or WASD to move your runner'],
    instructions = [
        'Collect all dots to advance to the next level',
        'Avoid the ghosts or eat power pellets to turn the tables!'
    ],
    isPositioned = false
}) => {
    const baseStyles = {
        color: '#FFFFFF',
        textAlign: 'center' as const,
        fontSize: '14px'
    };

    const positionedStyles = isPositioned ? {
        position: 'absolute' as const,
        top: '140px', // Position below debug info
        left: '-200px',
        backgroundColor: 'rgba(0,0,0,0.7)',
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #872d03',//00FF00
        width: '150px',
        minWidth: '150px',
        textAlign: 'left' as const
    } : {
        marginTop: '20px'
    };

    return (
        <div style={{ ...baseStyles, ...positionedStyles }}>
            <div style={{ marginBottom: '10px', color: '#FFFF00', fontWeight: 'bold' }}>
                CONTROLS
            </div>
            {controls.map((control, index) => (
                <div key={index} style={{ marginBottom: '5px' }}>{control}</div>
            ))}
            <div style={{ marginTop: '15px', marginBottom: '10px', color: '#00FF00', fontWeight: 'bold' }}>
                OBJECTIVE
            </div>
            {instructions.map((instruction, index) => (
                <div key={index} style={{ marginBottom: '5px' }}>{instruction}</div>
            ))}
        </div>
    );
};

export default ControlsInfo; 